<template>
  <div class="slotMachine">
    <!-- 返回 -->
    <div
      class="header-return"
      :style="{ top: 10.31 + statusBarHeight + 'px' }"
      @click="handleClosePage"
    >
      <img
        class="header-return-left"
        :src="require('@/assets/images/YuliApp/weeklyTask/button_return.svg')"
      />
      <!-- <img
        class="header-return-right"
        :src="require('@/assets/images/YuliApp/kudasaiChristmas/img_logo.png')"
      /> -->
    </div>
    <div class="slotMachine-block">
      <div class="header">
        <div class="header-time">
          <p class="header-time-text">
            {{ localesPackage?.['kudasai_christmas_title']?.[localesEnv] }}: {{ is_show_time ? deadline : "00:00(UTC+0) 00.00.0000" }}
          </p>
          <img
            :src="require('@/assets/images/YuliApp/kudasaiChristmas/tokyo_wenhao.png')"
            @click="showActivityIntro"
          />
        </div>
      </div>

      <!-- 老虎机九宫格 -->
      <tigerMachine
        :prizeListServe="prizeListServe"
        :isStart="isStart"
        :resultId="cur_reward_id"
        @handleEnd="handleEnd"
        @showpop="showpop"
      ></tigerMachine>

      <div class="bottom">
        <!-- 苹果碎片 -->
        <div class="bottom-apple">
          <div class="bottom-apple-count">
            {{ cur_apple_props > 999 ? "999+" : cur_apple_props }}/{{
              one_time_props
            }}
          </div>
        </div>

        <!-- 按钮 可以抽奖 -->
        <div class="bottom-start" v-if="button_type === 1" @click="handleStart">
          <img
            :src="
              require('@/assets/images/YuliApp/kudasaiChristmas/click@2x.png')
            "
          />
        </div>

        <!-- 按钮 不能抽奖 -->
        <div class="bottom-start" v-if="button_type === 0">
          <img
            :src="
              require('@/assets/images/YuliApp/kudasaiChristmas/noclick@2x.png')
            "
          />
        </div>

        <!-- 按钮 领取奖励 -->
        <div
          class="bottom-start"
          v-if="button_type === 2"
          @click="handleShowClaim(true)"
        >
          <img
            :src="
              require('@/assets/images/YuliApp/kudasaiChristmas/claim@2x.png')
            "
          />
        </div>
      </div>
    </div>

    <!-- 奖品详情 -->
    <ClaimedPopup
      v-if="is_show_pop"
      :cur_popup_info="cur_show_info"
      @close="handleClose"
    ></ClaimedPopup>

    <!-- 介绍 -->
    <ActivityIntro
      v-if="show_activity_intro"
      @close="handleCloseIntro"
    ></ActivityIntro>

    <!-- 领取奖品 -->
    <DrawPopup
      v-if="is_show_claim"
      :name="cur_reward_name"
      :img="cur_reward_img"
      :id="cur_reward_id"
      @close="handleShowClaim"
    ></DrawPopup>
  </div>
</template>

<script>
import {
  onBeforeMount,
  refs,
  nextTick,
  onMounted,
  ref,
  getCurrentInstance,
} from "vue";
import _ from "lodash";
import appBridging from "@/utils/appBridging.js";
import { mapState } from "vuex";
import { REWARD_TYPE, ERROR_TEXT } from "@/constants/enums";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import {
  getRewardList,
  GetRewardClaim,
  GetCountDown,
  GetProps,
} from "@/api/kudasaiChristmas.js";
import tigerMachine from "./components/tigerMachine";
import ClaimedPopup from "./components/ClaimedPopup";
import ActivityIntro from "./components/ActivityIntro";
import DrawPopup from "./components/DrawPopup";
import { getTime, getUtcTime } from "@/utils/time.js";
import audioManager from "@/utils/audioManager";
import reward_img from "@/assets/images/YuliApp/kudasaiChristmas/reward_card.png";
import {getSlotMachineLanguage} from "@/api/language.js";
import store from "@/store";

export default {
  components: {
    tigerMachine,
    ClaimedPopup,
    ActivityIntro,
    DrawPopup,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    init: {
      handler(value) {
        if (!value) {
          return;
        }
        this.initData();
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        console.log('languageEnv: ', value);
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        console.log('languagePackage: ', value);
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup() {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const prizeListServe = ref([]); //奖品列表来自服务的数据
    const isStart = ref(false);
    const is_show_pop = ref(false);
    const cur_show_info = ref(null);
    const show_activity_intro = ref(false);
    const button_type = ref(0); //0 不能抽 1能抽 2领取
    const is_show_claim = ref(false);
    const cur_apple_props = ref(0); // 当前道具持有数
    const one_time_props = ref(3); // 单次道具消耗数

    //
    const cur_reward_id = ref(-1);
    //
    const cur_reward_name = ref("");
    //
    const cur_reward_img = ref("");

    const deadline = ref("");
    const is_show_time = ref(false);

    onBeforeMount(async ()=>{
      appBridging.getSettingLaungage();
      const res = await getSlotMachineLanguage();
      store.dispatch("global/setLanguagePackage", res);// 存到stroe
    })

    onMounted(() => {
      
      appBridging.getStatusBarHeight();
      // initData();
    });

    const handleStart = async () => {
      audioManager.playEffect("bubble");
      proxy.$loading.show();

      button_type.value = 0;
      let data;
      try {
        data = await GetRewardClaim({ data: {} });
      } catch (error) {
        /**
         * 错误处理待补充
         */
        proxy.$toast.show({
          msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
          type: TOAST_TYPE.ERROR,
        });
        button_type.value = 1;
        proxy.$loading.hide();
        return;
      }
      const reward = _.get(data, "data", null);

      proxy.$loading.hide();
      if (reward) {
        /**
         * 抽中情况
         * 抽中只会返回id数据，其他为空
         */

        // 老虎机-最终落点位
        cur_reward_id.value = reward[0]?.grid_number;

        //通知移动端刷新背包数据
        appBridging.handleRefreshNativeCache('V1GetUProps');

        /**
         * 检索奖励id
         */
          prizeListServe.value.forEach((item) => {
          if (item.grid_number === cur_reward_id.value) {
            cur_reward_name.value = reward[0]?.name || item?.name;
            /**
             * 有图片返回就使用，没有则用检索数据
             * 针对抽到用户头像
             */
            cur_reward_img.value = reward[0]?.img_url || item?.img_url;
            if (cur_reward_name.value==='Hanazawa Kana') {
              cur_reward_img.value = reward_img
            }
          }
        });

      } else {
        /**
         * 未抽中函数
         * - 设置未抽中状态，和落点
         * - arr为会落点数组
         */
         const randomSelect = () => {
          // 未抽中会落点的位置 dex从1开始
          const arr = [3, 12];
          // 生成一个介于0和数组长度之间的随机索引
          const randomIndex = Math.floor(Math.random() * arr.length);
          
          // 返回被抽中的数组项
          const selectNum = arr[randomIndex];
          cur_reward_id.value = selectNum;
          cur_reward_img.value = require('@/assets/images/YuliApp/kudasaiChristmas/reward_get_none.png');
          cur_reward_name.value = 'Better luck next time';
        }
        
        randomSelect();
        // await reuqestGetProps();
        // handleSetButton();
        // proxy.$toast.show({
        //   msg: "data error",
        //   type: TOAST_TYPE.ERROR,
        // });
      }

      // 开启转盘
      isStart.value = true;

      try {
        audioManager.pauseCurBGM();
        audioManager.playEffect("lucky_go", 2);
      } catch (error) {
        console.log(error);
      }

      await reuqestGetProps();
      await requestGetRewardList();

      /**
       * 更新碎片，考虑网络延迟需要增加本地扣除逻辑
       */
      // cur_apple_props.value -= one_time_props
    };

    const handleEnd = (state, is_get_result, result_info) => {
      isStart.value = false;
      if (is_get_result) {
        // button_type.value = 2
        setTimeout(() => {
          button_type.value = 2;
          handleShowClaim(true);
        }, 800);
      }
    };

    /**
     * 初始化
     */
    const initData = async () => {
      await reuqestGetProps();
      handleSetButton();
      await requestGetRewardList();
      // await requestGetResult()
      await requestGetCountDown();
      appBridging.closeLoading();
      audioManager.playBgmMusic("leisure_bgm");
    };

    /**
     *
     */
    const reuqestGetProps = async () => {
      return GetProps().then((res) => {
        const data = _.get(res, "data", []) || [];
        if (data && data.length > 0) {
          cur_apple_props.value = data[0].count;
        } else {
          cur_apple_props.value = 0;
        }
      });
    };

    /**
     * 请求转盘奖品列表
     */
    const requestGetRewardList = () => {
      return getRewardList().then((res) => {
        const data = _.get(res, "data", []) || [];
        prizeListServe.value = data;
      });
    };

    /**
     * 请求抽奖结果
     */
    const requestGetResult = () => {
      return GetRewardClaim({ data: {} })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          // console.log("requestGetResult  err", err);
          /**
           * 错误处理待补充
           */
          proxy.$toast.show({
            msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
            type: TOAST_TYPE.ERROR,
          });
          button_type.value = 1;
        });
    };

    /**
     * 请求倒计时
     */
    const requestGetCountDown = () => {
      return GetCountDown().then((res) => {
        console.log("倒计时", res);
        const time = _.get(res, "data.end_time", "") * 1000;
        const is_show = _.get(res, "data.is_show", false);

        is_show_time.value = is_show;
        deadline.value =
          getUtcTime(time, "HH:mm") + "(UTC+0) " + getUtcTime(time, "DD.MM.YYYY");
        return 1;
      });
    };

    /**
     * 关闭页面
     */
    const handleClosePage = () => {
      appBridging.closePage();
    };

    const showpop = (state, info) => {
      // audioManager.playEffect("bubble");
      // cur_show_info.value = info;
      // is_show_pop.value = state;
    };

    const handleClose = () => {
      audioManager.playEffect("bubble");
      is_show_pop.value = false;
    };

    /**
     * 活动介绍
     */
    const showActivityIntro = () => {
      audioManager.playEffect("bubble");
      show_activity_intro.value = true;
    };
    const handleCloseIntro = () => {
      audioManager.playEffect("bubble");
      show_activity_intro.value = false;
    };

    const handleShowClaim = (state) => {
      if (state) {
        audioManager.playEffect("get_token");
      } else {
        audioManager.playEffect("bubble");
      }
      is_show_claim.value = state;
      handleSetButton();
    };

    const handleSetButton = () => {
      if (cur_apple_props.value < one_time_props.value) {
        button_type.value = 0;
      } else {
        button_type.value = 1;
      }
    };

    return {
      prizeListServe,
      handleClosePage,
      initData,
      handleStart,
      handleEnd,
      showpop,
      handleShowClaim,
      showActivityIntro,
      show_activity_intro,
      handleCloseIntro,
      handleClose,
      isStart,
      is_show_pop,
      cur_show_info,
      button_type,
      is_show_claim,
      deadline,
      is_show_time,
      one_time_props,
      cur_apple_props,
      cur_reward_id,
      cur_reward_name,
      cur_reward_img,
      localesPackage,
      localesEnv
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.slotMachine {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-image: url("~@/assets/images/YuliApp/kudasaiChristmas/tokyo_bg.png");
  background-size: 100% 100%;
  overflow: hidden;
  &-block {
    // overflow-y: scroll;
  }
  .header-return {
    position: absolute;
    width: 100%;
    height: 30px;
    text-align: left;
    z-index: 1;
    display: flex;
    align-items: center;
    &-left {
      position: absolute;
      left: -2px;
      top: 0;
      width: 64.07px;
      height: 30px;
    }
    &-right{
      position: absolute;
      right: 14px;
      width: 144px;
      height: 23px;
    }
  }

  .header {
    position: relative;
    width: 375px;
    height: 256px;
    background: url("~@/assets/images/YuliApp/kudasaiChristmas/bg_1@2x.png");
    background-size: 100% 100%;
    &-time {
      width: 100%;
      height: 16px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 10px;

      display: flex;
      align-items: center;
      justify-content: center;
      &-text {
        color: #FFFFFF;
        font-size: 13px;
        font-weight: 400;
        font-family: "Josefin Sans";
        text-align: center;
        // line-height: 18px;
        margin-right: 10px;
      }
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .bottom {
    margin-top: -2px;
    width: 375px;
    height: 226px;
    background: url("~@/assets/images/YuliApp/kudasaiChristmas/bg_3@2x.png");
    background-size: 100% 100%;
    &-apple {
      margin: 2px auto 0 auto;
      width: 186px;
      height: 46px;
      background: url("~@/assets/images/YuliApp/kudasaiChristmas/apple_suipian@2x.png");
      background-size: 100% 100%;

      &-count {
        color: rgba(58, 49, 76, 1);
        line-height: 46px;
        margin-left: 40px;
        text-align: center;
        font-size: 14px;
        font-family: "Josefin Sans";
        padding-top: 3px;
      }
    }
    &-start {
      margin: 10px auto 0 auto;
      width: 182px;
      height: 74px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .content {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    // height: 334px;
    position: relative;
    .tiger {
      position: relative;
      &-result {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 165px;
        height: 165px;
        border-radius: 2px;
        opacity: 1;
        background: rgba(172, 162, 188, 1);
        img {
          width: 85px;
          height: 127.5px;
        }
      }
    }

    &-start {
      background: #78a97b;
      width: 141.79px;
      height: 30px;
      color: #ffffff;
      border-radius: 10px;
      line-height: 30px;
    }

    .top-circleAll,
    .left-circleAll,
    .right-circleAll,
    .bottom-circleAll {
      box-sizing: border-box;
      // padding-top: 1px;
      height: 10px;
      width: 302px;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      position: absolute;
      top: 1px;
      left: 9px;
      &-radius {
        box-sizing: border-box;
        flex-shrink: 0;
        width: 6px;
        height: 6px;
        opacity: 1;
        border-radius: 50%;
      }

      .top-circleAll-radius:nth-of-type(even) {
        background: rgba(223, 157, 255, 1);
        box-shadow: 0 0 2px 0 rgba(255, 123, 250, 1);
        animation: evenShan 1s ease-in-out infinite alternate;
      }
      .top-circleAll-radius:nth-of-type(odd) {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 1px 0 rgba(255, 243, 134, 0.5),
          0 0 2px 0 rgba(255, 203, 69, 0.5);
        animation: oddShan 1s ease-in-out infinite alternate;
      }
      @keyframes evenShan {
        0% {
          // transform: scale(1);
          background: #c96cf6;
          box-shadow: 0 0 2px 0 #fa4ef3;
        }
        20% {
          opacity: 0.2;
        }
        100% {
          opacity: 1;
          // transform: scale(0.8);
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 0 1px 0 rgba(255, 243, 134, 0.5),
            0 0 2px 0 rgba(255, 203, 69, 0.5);
        }
      }
      @keyframes oddShan {
        0% {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 0 1px 0 rgba(255, 243, 134, 0.5),
            0 0 2px 0 rgba(255, 203, 69, 0.5);
        }
        20% {
          opacity: 0.2;
        }
        100% {
          opacity: 1;
          background: #c96cf6;
          box-shadow: 0 0 2px 0 #fa4ef3;
        }
      }
    }
    .left-circleAll {
      position: absolute;
      left: 0;
      top: 17px;
      height: 284px;
      width: 10px;
      flex-direction: column;
      align-items: center;
    }
    .right-circleAll {
      z-index: 10;
      position: absolute;
      left: unset;
      right: -1px;
      top: 17px;
      height: 284px;
      width: 10px;
      flex-direction: column;
      align-items: center;
    }
    .bottom-circleAll {
      bottom: -2px;
      top: unset;
    }
  }
  //   .outside {
  //     width: 100%;
  //     height: 100%;
  //   }
}

@media screen and (max-height: 670px) {
  .slotMachine {
    .header {
      height: 208px;
      background: url("~@/assets/images/YuliApp/kudasaiChristmas/bg_1@2x_667.png");
      background-size: 100% 100%;
      &-time {
        bottom: 10px;
      }
    }
    .bottom {
      width: 375px;
      height: 128px;
      background: url("~@/assets/images/YuliApp/kudasaiChristmas/667.png");
      background-size: 100% 100%;
    }
  }
}

@media screen and (min-width: 411px) and (max-height: 812px) {
  .slotMachine {
    .header {
      height: 210px;
      background: url("~@/assets/images/YuliApp/kudasaiChristmas/bg_1@2x.png");
      background-size: 100% 100%;
    }
    // .bottom {
    //   width: 375px;
    //   height: 128px;
    //   background: url("~@/assets/images/YuliApp/kudasaiChristmas/667.png");
    //   background-size: 100% 100%;
    // }
  }
}
</style>
